import React from "react";
import { ClockOutlined, TickDoubleOutlined } from "@toddle-edu/ds-icons";

const ReadReceipt = props => {
  const { isSent, isRead, isSender } = props;

  const Icon = isSent ? TickDoubleOutlined : ClockOutlined;
  const iconProps = isSent
    ? { variant: isRead ? "link" : "subtle", size: "xxx-small" }
    : { variant: "subtle", size: "xxxx-small" };

  return isSender ? <Icon {...iconProps} /> : null;
};

export default ReadReceipt;
